import { Component, OnInit, Inject, ViewEncapsulation, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
declare var tarteaucitron: any;
import * as tarteaucitron from '../../../assets/tarteaucitron/tarteaucitron.js';
import { DOCUMENT } from '@angular/common';
import { ApiService, MiscConfig } from 'angular-lib';

@Component({
    selector: 'ez-tarteaucitron',
    template: require('./tarteaucitron.component.html'),
    styles: [require('./tarteaucitron.component.less')],
    encapsulation: ViewEncapsulation.None
})


export class TarteaucitronComponent implements OnInit {
    private showCookies: boolean = false;
    private cookiesInformations: any;

    constructor(
        private translate: TranslateService,
        @Inject(DOCUMENT) private document: any,
        private router: Router,
        private apiService: ApiService
    ) {}

    public ngOnInit() {
        this.apiService.miscConfig().subscribe((res) => {
            this.cookiesInformations = res.cookiesInformations;
        });

        let locale = 'en';
        if (localStorage.getItem('locale')) {
            locale = localStorage.getItem('locale');
        }

        this.taCInit(locale);

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            (window as any).tarteaucitronForceLanguage = event.lang.split('_')[0];
            let existingElement = this.document.querySelector('#tarteaucitronRoot');
            if (existingElement) {
                existingElement.remove();
                tarteaucitron.added = {};
                tarteaucitron.load();
            }

            this.apiService.miscConfig().subscribe((miscConfig: MiscConfig) => {
                this.cookiesInformations = miscConfig.cookiesInformations;
            });
        });
    }

    public taCInit(locale) {
        tarteaucitron.init({
            'hashtag': '#tarteaucitron',
            'highPrivacy': true,
            'orientation': 'bottom',
            'adblocker': false,
            'showAlertSmall': false,
            'cookieslist': true,
            'removeCredit': true
        });

        tarteaucitron.user.gajsUa = 'UA-1775268-76';
        tarteaucitron.user.analyticsUa = 'UA-1775268-76';
        tarteaucitron.job = [];
        tarteaucitron.job.push('gajs');
        tarteaucitron.job.push('analytics');

        (window as any).tarteaucitronForceLanguage = locale.split('_')[0];
    }

    public openPanel() {
        tarteaucitron.userInterface.openPanel();
    }

    public close() {
        this.showCookies = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/tarteaucitron/tarteaucitron.component.ts